import React, { useState, useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import './GraficoRespostas.css';

const getHorizontalBarChartOptions = (scores, selectedIndex) => ({
  tooltip: {
    trigger: 'axis',
    axisPointer: { type: 'shadow' }
  },
  grid: { left: 100, right: 40 },
  xAxis: {
    type: 'value',
    min: 0,
    max: 100,
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: { show: false },
    splitLine: { show: false }
  },
  yAxis: {
    type: 'category',
    data: scores.map(item => item.questionario_nome),
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: {
      fontSize: 14,
      color: '#333',
      triggerEvent: true
    }
  },
  series: [
    {
      type: 'bar',
      data: scores.map(() => 100),
      barWidth: '60%',
      barGap: '-100%',
      itemStyle: { color: '#E0E0E0' },
      emphasis: { itemStyle: { color: '#D5D5D5' } },
      z: 0
    },
    {
      type: 'bar',
      data: scores.map((item, idx) => ({
        value: parseFloat(item.score),
        itemStyle: {
          color: idx === selectedIndex ? '#5470C6' : '#777777',
          borderRadius: [2, 2, 2, 2]
        }
      })),
      barWidth: '60%',
      barGap: '-100%',
      label: {
        show: true,
        position: 'outside',
        formatter: ({ value }) => isNaN(parseFloat(value)) ? '' : parseFloat(value).toFixed(1),
        fontSize: 14,
        color: '#333'
      },
      z: 1
    }
  ]
});

const ScoreDashboard = ({ scores = [] }) => {
  const [selected, setSelected] = useState(null);

  const sortedScores = useMemo(
    () => [...scores].sort((a, b) => parseFloat(a.score) - parseFloat(b.score)),
    [scores]
  );
  const exibirGrafico = scores.length > 1;

  const handleClick = params => {
    const idx = params.dataIndex;
    if (idx != null && idx >= 0) {
      setSelected(sortedScores[idx]);
    }
  };

  const selectedIndex = sortedScores.findIndex(
    item => item.questionario_nome === selected?.questionario_nome
  );

  const rawTitulo =
    scores.length > 1
      ? 'Padrão'
      : scores[0]?.questionario_nome || 'Desconhecido';
  const titulo = `Questionário ${rawTitulo}`;

  const formatarData = dataStr => {
    if (!dataStr) return null;
    const [d, m, y] = dataStr.split('/');
    const dt = new Date(parseInt(y), parseInt(m, 10) - 1, parseInt(d, 10));
    return dt.toLocaleDateString('pt-BR');
  };
  const dataResposta = formatarData(scores[0]?.data);

  return (
    <div className="scoreDashboardWrapper">
      <div className="scoreDashboardHeader">
        <h2 className="questionarioTitulo">{titulo}</h2>
        {dataResposta && (
          <span className="dataResposta">
            Data da resposta: {dataResposta}
          </span>
        )}
      </div>

      <div className="scoreDashboardContainer">
        {exibirGrafico ? (
          <div className="chartsRow">
            <div className="chartItem">
              <ReactECharts
                option={getHorizontalBarChartOptions(
                  sortedScores,
                  selectedIndex
                )}
                style={{ height: 400, width: '100%', cursor: 'pointer' }}
                onEvents={{ click: handleClick }}
              />
            </div>
            <div className="chartItem">
              <div className="respostaBox">
                {selected ? (
                  <div className="respostaLista">
                    {selected.respostas.map((res, i) => (
                      <div key={i} className="respostaItem">
                        <p className="perguntaTexto">{res.pergunta}</p>
                        <p className="respostaTexto">{res.resposta}</p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p>
                    Clique na barra para ver as
                    respostas.
                  </p>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="respostaBox">
            <div className="respostaLista">
              {scores.map((sc, i) =>
                sc.respostas?.map((res, j) => (
                  <div key={`${i}-${j}`} className="respostaItem">
                    <p className="perguntaTexto">{res.pergunta}</p>
                    <p className="respostaTexto">{res.resposta}</p>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScoreDashboard;
